import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useUserContext } from '@magento/peregrine/lib/context/user';
/**
 * @typedef {function} useSignInPage
 *
 * @param {String} props.createAccountPageUrl - Create Account Password Page url
 * @param {String} props.forgotPasswordPageUrl - Forgot Password Page url
 * @param {String} props.signedInRedirectUrl - Url to push when user is signed in
 *
 * @returns {{
 *   signInProps: object
 * }}
 */

export var useSignInPage = function useSignInPage(props) {
  var createAccountPageUrl = props.createAccountPageUrl,
      forgotPasswordPageUrl = props.forgotPasswordPageUrl,
      signedInRedirectUrl = props.signedInRedirectUrl;
  var history = useHistory();

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      isSignedIn = _useUserContext2[0].isSignedIn; // Keep location state in memory when pushing history and redirect to
  // the `from` url instead when signing in


  var historyState = useMemo(function () {
    return history && history.location.state ? history.location.state : {};
  }, [history]);
  var fromRedirectUrl = historyState.from || null; // Redirect if user is signed in

  useEffect(function () {
    if (isSignedIn) {
      if (fromRedirectUrl || signedInRedirectUrl) {
        history.push(fromRedirectUrl || signedInRedirectUrl);
      }
    }
  }, [history, isSignedIn, fromRedirectUrl, signedInRedirectUrl]);
  var handleShowCreateAccount = useCallback(function () {
    if (createAccountPageUrl) {
      history.push(createAccountPageUrl, historyState);
    }
  }, [createAccountPageUrl, history, historyState]);
  var handleShowForgotPassword = useCallback(function () {
    if (forgotPasswordPageUrl) {
      history.push(forgotPasswordPageUrl, historyState);
    }
  }, [forgotPasswordPageUrl, history, historyState]);
  var signInProps = {
    classes: {
      modal_active: undefined
    },
    showCreateAccount: handleShowCreateAccount,
    showForgotPassword: handleShowForgotPassword
  };
  return {
    signInProps: signInProps
  };
};